import { NgFor, NgIf, isPlatformBrowser } from '@angular/common';
import { Component, Input, OnChanges, PLATFORM_ID, inject } from '@angular/core';
import { ScreenSizes } from 'src/app/classes/screen-sizes.class';
import { getPictureSourceSizes } from 'src/app/storyblok/custom-rich-text';
import { getResizeUrl } from 'src/app/storyblok/get-resize-url';
import { ResizeDirective } from '../../directives/resize.directive';

@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  standalone: true,
  imports: [NgIf, ResizeDirective, NgFor],
})
export class PictureComponent implements OnChanges {
  @Input() url: string;
  @Input() mobileUrl: string;
  /**
   * Scale of the image between 0 and 1
   */
  @Input() scale: number;
  @Input() width: number;
  @Input() height: number;
  @Input() maxWidth: number;
  @Input() mobileWidth: number;
  @Input() mobileHeight: number;
  @Input() loading = 'lazy';
  @Input() alt: string;
  srcset: { [size: string]: string };
  mobileSrcset: { [size: string]: string };
  fetchPriority: 'auto' | 'high' | 'low' = 'auto';
  sizes: number[];
  isMobile = false;

  private platformId = inject(PLATFORM_ID);

  ngOnChanges() {
    if (!this.url) return (this.srcset = undefined);
    if (this.loading === 'eager') this.fetchPriority = 'high';
    if (!this.loading) this.loading = 'lazy';

    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = ScreenSizes.screenSize() === 'mobile';
    }

    this.srcset = {};
    this.mobileSrcset = {};
    this.sizes = getPictureSourceSizes(this.url, this.maxWidth / this.scale);

    this.sizes.forEach((size, i) => {
      const sizeKey = size;
      let biggerSize = this.sizes[i - 1];
      if (!biggerSize) return;
      const mobileSize = biggerSize - 30; // 15px padding on each side
      biggerSize = biggerSize * this.scale;
      this.srcset[`size-${sizeKey}`] = `${getResizeUrl(this.url, biggerSize)}, ${getResizeUrl(
        this.url,
        biggerSize * 2
      )} 2x`;
      if (this.mobileUrl) {
        this.mobileSrcset[`size-${sizeKey}`] = `${getResizeUrl(this.mobileUrl, mobileSize)}, ${getResizeUrl(
          this.mobileUrl,
          mobileSize * 2
        )} 2x`;
      }
    });
  }

  getInSize(src: string, size: number) {
    return getResizeUrl(src, size);
  }
}
